<template>
  <div class="not-found">
    <h2>404</h2>
  </div>
</template>

<script>
export default {
  name: 'not-found',
  components: {
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style>
.not-found {
}
</style>




// WEBPACK FOOTER //
// NotFound.vue?416cd7f0